import React from "react";
import { Box, Container } from "@material-ui/core";
import { useAuth } from "../../../utils/use-auth";
import TopHeaderMenu from "./TopHeaderMenu";
import LanguageSwitcher from "./LanguageSwitcher";

const TopHeader = () => {
  const { isLoggedIn } = useAuth();

  return (
    <Container>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        minHeight="40px"
      >
        {isLoggedIn && <TopHeaderMenu />}
        <Box display="flex" alignItems="center" justifyContent="center">
          <LanguageSwitcher />
        </Box>
      </Box>
    </Container>
  );
};

export default TopHeader;
